export const dstDataLocators = {
    dst_map_marker: 'dst_map_marker',
    dst_trainer_card: 'dst_trainer_card',
    dst_trainer_card_email: 'dst_trainer_card_email',
    dst_trainer_card_phone: 'dst_trainer_card_phone',
    dst_trainer_card_get_directions: 'dst_trainer_card_get_directions',
    dst_trainer_card_view_more: 'dst_trainer_card_view_more',
    current_location_cta:'current_location_cta'
}
